// src/pages/projects/ProjectConfig.js

const PROJECTS = [
    {
        id: 1,
        caption: 'ASCII Tetris',
        src: '/projects/ascii_tetris.jpg',
        path: '/projects/1',
        year: 'Freshman Year Project'
    },
    {
        id: 2,
        caption: 'Digital Logic Hole in the Wall',
        src: '/projects/project2/dld_logisim_final_project.png',
        path: '/projects/2',
        year: 'Freshman Year Project'
    },
    {
        id: 3,
        caption: 'Mini CAN-Bus',
        src: '/projects/arduino-communication-diagram.png',
        path: '/projects/3',
        year: 'Freshman Year Project'
    },
    {
        id: 4,
        caption: 'The BookCooper',
        src: '/projects/bookcooper.png',
        path: '/projects/4',
        year: 'Sophomore Year Project'
    },
    {
        id: 5,
        caption: '16-Bit CPU',
        src: '/projects/project5/comparch-cpu-diagram-textbook.png',
        path: '/projects/5',
        year: 'Sophomore Year Project'
    },
    {
        id: 6,
        caption: 'Theremin',
        src: '/projects/sophomore_theremin_cropped.jpg',
        path: '/projects/6',
        year: 'Sophomore Year Project'
    },
    {
        id: 7,
        caption: 'Financial Sentiment Analyzer',
        src: '/projects/project7/nlp-final-overview.png',
        path: '/projects/7',
        year: 'Junior Year Project'
    },
    {
        id: 8,
        caption: 'Single-Balanced Active Mixer',
        src: '/projects/project8/jlab1-output-oscilloscope.png',
        path: '/projects/8',
        year: 'Junior Year Project'
    },
    {
        id: 9,
        caption: 'Cocktail Party Problem',
        src: '/projects/junior-gen-ml-cropped.jpg',
        path: '/projects/9',
        year: 'Junior Year Project'
    },
    {
        id: 10,
        caption: 'ScopeTV',
        src: '/projects/scopetv.png',
        path: '/projects/10',
        year: 'Junior Year Project'
    },
    {
        id: 11,
        caption: 'Multimodal Caption Verifier',
        src: '/projects/multimodal_caption_verifier.png',
        path: '/projects/11',
        year: 'Junior Year Project'
    },
    //{
        //id: 12,
        //caption: 'Differential to Single Ended Amplifier',
        //src: '/projects/project12/elec2-diff-amplifier-layout-zoomed.png',
        //path: '/projects/12',
        //year: 'Junior Year Project'
    //},
    {
        id: 13,
        caption: 'C99 Compiler',
        src: '/projects/compiler_tiny.png',
        path: '/projects/13',
        year: 'Junior Year Project'
    },
    {
        id: 14,
        caption: 'Environmental Impact of AI Models',
        src: '/projects/project14/ethics_waterfall.png',
        path: '/projects/14',
        year: 'Junior Year Project'
    },
    {
        id: 15,
        caption: 'Sparse Autoencoder',
        src: '/projects/project15/sae_top_features_max.png',
        path: '/projects/15',
        year: 'Senior Year Project'
    },
    {
        id: 16,
        caption: 'Dear Address',
        src: '/projects/senior_da_wall_cleaned.png',
        path: '/projects/16',
        year: 'Senior Year Project'
    },
    // {
    //     id: 17,
    //     caption: 'Multi-headed attention Transformer',
    //     // src: '/projects/project15/--------------',
    //     path: '/projects/17',
    //     year: 'Senior Year Project'
    // },
];

export default PROJECTS;

